import { $SalesforceResource } from 'app/resources';

export interface CaseCreatePayload {
    org_id: string,
    user_id: string,
    record_type_id?: string,
    origin: string,
    case_type?: string,
    priority?: string,
    subject: string,
    description?: string,
    files?: any[]
};

export class SalesforceService {
    public static initialize(env: string, token: string) {
        return $SalesforceResource.initialize(env, token);
    }

    public static createCase(data: CaseCreatePayload) {
        return $SalesforceResource.post(`caseCreate`, {}, data);
    }
}
